// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FilesCodingIconSignature {
  Element: SVGSVGElement;
}

export const FilesCodingIcon: TOC<FilesCodingIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.293 10.299L6.586 14.006L10.293 17.714L11.707 16.299L9.414 14.006L11.707 11.714L10.293 10.299ZM12.293 11.714L14.586 14.006L12.293 16.299L13.707 17.714L17.414 14.006L13.707 10.299L12.293 11.714ZM16.414 1.00299H5C3.897 1.00299 3 1.89899 3 3.00299V21.003C3 22.106 3.897 23.003 5 23.003H19C20.103 23.003 21 22.106 21 21.003V5.58999L16.414 1.00299ZM5 21.003V3.00299H15V7.00299H19L19.001 21.003H5Z"/>
</svg>
</template>;